import { create } from "zustand";
import { DeepScanResultType, IndicatorStatusType, InsightDataType, ScanResultByGroupIdType } from "../types";
import { ThreatType } from "../components/threat/threat.config";


type TabState = {
    insightData: Partial<InsightDataType>;
    setInsightData: (insightData: InsightDataType) => void;

    deepScanData: Partial<DeepScanResultType>;
    setDeepScanData: (deepScanData: DeepScanResultType) => void;

    reportSent: boolean;
    setReportSent: (reportSent: boolean) => void;

    // New state for monitoring scan status
    threatItems: Partial<ScanResultByGroupIdType>;
    setThreatItems: (threatItems: Partial<ScanResultByGroupIdType>) => void;

    indicatorStatus: IndicatorStatusType;
    setIndicatorStatus: (indicatorStatus: IndicatorStatusType) => void;

};

export const useResultStore = create<TabState>((set) => ({

    insightData: {},
    setInsightData: (insightData) => set({ insightData }),

    deepScanData: {},
    setDeepScanData: (deepScanData) => set({ deepScanData }),

    reportSent: false,
    setReportSent: (reportSent) => set({ reportSent }),

    // Initial state for new properties
    threatItems: {},
    setThreatItems: (threatItems) => set({ threatItems }),

    indicatorStatus: {},
    setIndicatorStatus: (indicatorStatus) => set({ indicatorStatus }),
}));


export const useIsScanning = () => {
    return useResultStore((state) => {
        const allItems = Object.values(state.threatItems ?? {}).flat();

        if (allItems.length === 0) return false;

        // Check if all items are either COMPLETED or FAILED
        return !allItems.every((item) =>
            item.scan_status === "COMPLETED" || item.scan_status === "FAILED"
        );
    });
};